<section style="background-color:#f2f3f8!important; margin-top: 2rem;" class="">
  <div class="pt-5 px" >
    <div id="wizard" role="application" class="wizard clearfix " >
        <div class="steps clearfix" id="v-pills-tab" >
            <ul role="tablist" class="nav nav-pills" >
                <li class="nav-items">
                  <a class="fineClass" [ngClass]="tab1cont ? 'nav-link active' : 'nav-link' "  data-toggle="pill" 
                    role="tab" id="tab1"  (click)="gotopage($event.target)">
                       <div class="media">
                         <div class="bd-wizard-step-icon"><i class="bi bi-person"></i></div>
                          <div class="media-body">
                           <div class="bd-wizard-step-title" id="tab1" style="cursor: pointer;">Personal Details</div>
                          </div>
                      </div>
                  </a>
              </li>
              <li>
                <a class="fineClass" [ngClass]="tab2cont ? 'nav-link active' : 'nav-link' "  data-toggle="pill" 
                role="tab" id="tab2" (click)="gotopage($event.target)">
              <div class="media">
          <div class="bd-wizard-step-icon"><i class="bi bi-award"></i></div>
          <div class="media-body">
            <div class="bd-wizard-step-title" id="tab2" style="cursor: pointer;">Educational Details</div>
          </div>
        </div>
      </a></li>
      <li>
        <a class="fineClass" [ngClass]="tab3cont ? 'nav-link active' : 'nav-link' "  data-toggle="pill" 
        role="tab" id="tab3" (click)="gotopage($event.target)">
        <div class="media">
          <div class="bd-wizard-step-icon"><i class="bi bi-person-check"></i></div>
          <div class="media-body">
            <div class="bd-wizard-step-title" id="tab3" style="cursor: pointer;">Document Upload</div>
          </div>
        </div>
      </a></li>
        <li>
          <a class="fineClass" [ngClass]="tab4cont ? 'nav-link active' : 'nav-link' "  data-toggle="pill" 
          role="tab" id="tab4" (click)="gotopage($event.target)">
          <div class="media">
            <div class="bd-wizard-step-icon"><i class="bi bi-bank2"></i></div>
            <div class="media-body">
              <div class="bd-wizard-step-title" id="tab4" style="cursor: pointer;">Payment Details</div>
            </div>
          </div>
        </a></li></ul>
      </div>
          <!-- <div class="content clearfix tab-content " id="v-pills-tabContent" style="height:24rem;width:100%;overflow:scroll;overflow-x:hidden;overflow-y:scroll;"> -->
            <div class="content clearfix tab-content " id="v-pills-tabContent" style="height:100%;width:100%;overflow-x:hidden;overflow-y:auto;">
             <section [ngClass]="tab1cont ? 'tab-pane fade show active' : 'tab-pane fade' " id="tab1cont" role="tabpanel">
        <form method="post" role="form" #form="ngForm" [formGroup]="Requestform" (ngSubmit)="onSubmit(Requestform.value)"> 
          <div class="content-wrapper">
          <h4 class="section-heading mb-3">Personal details</h4>
                <div class="form-group">
                  <div class="row">
                    <label class="control-label">Full name as shown in the marksheet card:<span class="strip">*</span></label>
                    <!-- <div class="col-md-2">
                        <select  aria-label="Default select example" [attr.disabled]="formdisable"  formControlName="saluation" name="saluation" id="saluation" class=" form-select" 
                        [ngClass]="{ 'is-invalid': submitted && f.saluation.errors }">
                          <option selected  >Shri</option>
                          <option value="Shri">Shri</option>
                          <option value="Kumari">Kumari</option>
                          <option value="Kumar">Kumar</option>
                          <option value="Smt">Smt</option> 
                        </select>
                        <div *ngIf="submitted && f.saluation.errors" class="invalid-feedback">
                          <div *ngIf="f.saluation.errors.required">Saluation is required</div>
                       </div>
                    </div> -->
                    <div class="col-md-12">
                        <input type="text" [attr.disabled]="formdisable" formControlName="stud_name" name="stud_name" id="stud_name"   class="form-control" placeholder="Full name as shown in the marksheet card"
                        [ngClass]="{ 'is-invalid': submitted && f.stud_name.errors }" />
                        <div *ngIf="submitted && f.stud_name.errors" class="invalid-feedback">
                          <div *ngIf="f.stud_name.errors.required">Full name is required</div>
                         </div>
                    </div>
                    <!-- <div class="col-md-6">
                      <label class="control-label">Date of birth:<span class="strip">*</span></label>
                      <div class="">
                  <input type="date" formControlName="birthdate" name="birthdate" id="birthdate"  class="form-control" 
                  [ngClass]="{ 'is-invalid': submitted && f.birthdate.errors }"/>
                  <div *ngIf="submitted && f.birthdate.errors" class="invalid-feedback">
                    <div *ngIf="f.birthdate.errors.required">Date of birth is required</div>
                   </div>
                </div>
                    </div> -->
            </div>
           
          </div>
                <!--<div class="form-group">
                   <div class="row">
                   <div class="col-md-6">
                 <label class="control-label">Pr. No.:<span class="strip">*</span></label>
                  <div class="">
                  <input type="number" formControlName="stud_PR_no" name="stud_PR_no" id="stud_PR_no" placeholder="PR Number" class="form-control" 
                  [ngClass]="{ 'is-invalid': submitted && f.stud_PR_no.errors }"/>
                  <div *ngIf="submitted && f.stud_PR_no.errors" class="invalid-feedback">
                    <div *ngIf="f.stud_PR_no.errors.required">Enter PR_no is required</div>
                   </div>
                 </div>
                  </div>
               <div class="col-md-6">
               <label class="control-label">Gender:<span class="strip">*</span></label>
               <div class="">
               <select aria-label="Default select example"   formControlName="gender" name="gender" id="gender" class="form-control"
               [ngClass]="{ 'is-invalid': submitted && f.gender.errors }">
                       <option value=""  selected="selected">-Select-</option> 
                       <option value="Female">Female</option>
                       <option  value="Male" >Male</option>
                     </select>
                <div *ngIf="submitted && f.gender.errors" class="invalid-feedback">
                <div *ngIf="f.gender.errors.required">Gender is required</div>
              </div>
              </div>
              </div>
              </div> 
              </div>-->
              <div class="form-group">
                <div class="row">
                <div class="col-md-6">
                <label class="control-label">Email:<span class="strip">*</span></label>
                  <div class="">
                  <input type="text" [attr.disabled]="formdisable" formControlName="email_address" name="email_address" id="email_address" placeholder="Email" class="form-control ng-pristine ng-untouched ng-valid" value=""
                   [ngClass]="{ 'is-invalid': submitted && f.email_address.errors }"/>
                   <div *ngIf="submitted && f.email_address.errors" class="invalid-feedback">
                    <div *ngIf="f.email_address.errors.required">Email address is required</div>
                   </div>
                   </div>
                   </div>
                    <div class="col-md-6">
                   <label class="control-label"> Mobile:<span class="strip"></span></label>
                     <div class="" >
                    <input type="number"   formControlName="mobile_no"  name="mobile_no" id="mobile_no"   placeholder="Mobile number" class="form-control" value="" 
                    [ngClass]="{ 'is-invalid': submitted && f.mobile_no.errors }" pattern="[1-9]{1}[0-9]{9}" onKeyPress="if(this.value.length==10) return false;" /> 
                    <div *ngIf="submitted && f.mobile_no.errors" class="invalid-feedback">
                   <div *ngIf="f.mobile_no.errors.required">Mobile no. is required</div>
                   <div *ngIf="f.mobile_no.errors.pattern">Mobile nuber must be 10 digit Number</div>
                     </div>
                  </div>
                 </div> 
                </div>
            </div> 
            <div class="form-group">
              <div class= "row">
                <div class="col-md-6">
                      <label class="control-label">Address:<span class="strip">*</span></label>
                      <div class="">
                        <textarea rows="4" formControlName="address"  name="address" id="address" class="form-control" value=""
                          [ngClass]="{ 'is-invalid': submitted && f.address.errors }" style="height: 6rem;"></textarea>
                          
                          <div *ngIf="submitted && f.address.errors" class="invalid-feedback">
                            <div *ngIf="f.address.errors.required">Address is required</div>
                              </div>
                        </div>
                  </div>
                  <div class="col-md-6">
                    <label class="control-label"> Pincode:<span class="strip"></span></label>
                      <div class="">
                        <input type="number" formControlName="pincode"  name="pincode" id="pincode" 
                        class="form-control" [ngClass]="{ 'is-invalid': submitted && f.pincode.errors }">
                          <div *ngIf="submitted && f.pincode.errors" class="invalid-feedback">
                             <div *ngIf="f.pincode.errors.required">Pincode is required</div>
                          </div>
                      </div>
                     </div>
                                    
                </div> 
              </div>
              
          <div class="actions">
            <ul class="" style="text-decoration: none; list-style: none;">
              <!-- <li aria-hidden="false" aria-disabled="false">
                <input type="submit" value="Save" class="btn btn-warning  btn-block btnlogin  m-1">
              </li> -->
              <li aria-hidden="false" aria-disabled="false">
                <input value="Next" type="button" class="btn-secondary btn  btn-block btnlogin  m-1" (click)="opennexttab('tab1cont')">
              </li></ul></div>
              </div>
              </form>
      </section>
      <section [ngClass]="tab2cont ? 'tab-pane fade show active' : 'tab-pane fade' " id="tab2cont" role="tabpanel">
        <form method="post" role="form" #form="ngForm" [formGroup]="Requestform" (ngSubmit)="onSubmit(Requestform.value)"> 
        <div class="content-wrapper">
          <h4 class="section-heading mb-3">Educational details</h4>
          <div class="form-group">
              <div class="row">
                  <div class="col-md-4">
                            <label class="control-label">Standard<span class="strip">*</span></label>
                            <input type="text" [attr.disabled]="formdisable"  formControlName="standard"  name="standard" id="standard" class="form-control"  maxlength="50" value="" 
                            [ngClass]="{ 'is-invalid': submitted && f.standard.errors }"/>
                            <div *ngIf="submitted && f.standard.errors" class="invalid-feedback">
                              <div *ngIf="f.standard.errors.required">Standard is required</div>
                            </div>
                          </div>   
                    <div class="col-md-4">
                      <label class="control-label">School Index:<span class="strip">*</span></label>
                      <div class="">
                            <input type="text" formControlName="school_name"  name="school_name" id="school_name" placeholder="" class="form-control"
                            [ngClass]="{ 'is-invalid': submitted && f.school_name.errors }" (change)="checkifstudentisvalid()"/>
                            
                            <div *ngIf="submitted && f.school_name.errors" class="invalid-feedback">
                              <div *ngIf="f.school_name.errors.required">School Index is required</div>
                            </div>
                            
                          </div> 
                          
                      </div>
                                              
                  </div>
                  </div>

        <!-- ngIf: userId && isAdmin -->
      <div class="form-group">
            <div class="row">
                <div class="col-md-4">
                    <!-- <label class="control-label">Date of Passing<span class="strip">*</span></label>
                    <div class="">
                        <input type="date" formControlName="passing_month_year"  name="passing_month_year" id="passing_month_year"  class="form-control"
                        [ngClass]="{ 'is-invalid': submitted && f.passing_month_year.errors }"/>
                        <div *ngIf="submitted && f.passing_month_year.errors" class="invalid-feedback">
                          <div *ngIf="f.passing_month_year.errors.required">Passing year is required</div>
                            </div>
                    </div> -->
                    <label class="control-label">Month and Year of exam<span class="strip">*</span></label>
                    <div class="">
                        <input type="text" formControlName="exam_month_year" placeholder="eg: APRIL 2020"  name="exam_month_year" id="exam_month_year"  class="form-control"
                        [ngClass]="{ 'is-invalid': submitted && f.exam_month_year.errors }" (change)="checkifstudentisvalid()"/>
                        <span *ngIf="!(submitted && f.exam_month_year.errors)" class="text-secondary">Exam Month and Year should same as eg: given </span>
                        <div *ngIf="submitted && f.exam_month_year.errors" class="invalid-feedback">
                          <div *ngIf="f.exam_month_year.errors.required">Exam Month year is required is given format</div>
                            </div>
                      </div>
                </div>
                <!-- <div class="col-md-3">
                  <label class="control-label">Birthdate(DD/MM only):<span class="strip">*</span></label>
                  <div class="">
                    <input type="text" formControlName="ddmmbirthdate"  name="ddmmbirthdate" id="ddmmbirthdate"  class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.ddmmbirthdate.errors }"/>
                    <div *ngIf="submitted && f.ddmmbirthdate.errors" class="invalid-feedback">
                      <div *ngIf="f.ddmmbirthdate.errors.required">Birth date and month is required</div>
                        </div>
                  </div>
                </div> -->
                <div class="col-md-4">
                    <label class="control-label">Seat no of {{selectedstandard}} exam:<span class="strip">*</span></label>
                    <div class="">
                        <input type="number"  formControlName="seat_no"  name="seat_no" id="seat_no"  placeholder="Seat no of last exam" class="form-control"
                        (change)="checkifstudentisvalid()" [ngClass]="{ 'is-invalid': submitted && f.seat_no.errors }"/>
                        <div *ngIf="submitted && f.seat_no.errors" class="invalid-feedback">
                          <div *ngIf="f.seat_no.errors.required">Seat no. is required</div>
                            </div>
                    </div>
                </div>
                
                <div class="col-md-4 d-flex">
                  <!-- <label class="control-label">Varified</label> -->
                      <img class="mt-2" *ngIf="validstudent" style="height: 5rem; width: 5rem;" [src]="validstudent">
                      <span *ngIf="failstudentmsg" class="strip mt-3">{{failstudentmsg}}</span>
                </div>
            </div>
        </div>
          <div class="form-group">
          <div class="row">
                 <div class="" >
                      
                </div>
              </div>
        </div>
        
        <div class="actions">
            <ul>
              <!-- <li aria-hidden="false" aria-disabled="false">
                <input type="submit" value="Save" class="btn btn-warning  btn-block btnlogin  m-1">
               </li> -->
               <li aria-hidden="false" aria-disabled="false">
                <input value="Previous" type="button" class="btn btn-secondary  btn-block btnlogin  m-1" (click)="openpretab('tab1cont')">
              </li>
              <li aria-hidden="false" aria-disabled="false">
                <input value="Next" type="button" [attr.disabled]="disabledflagnoninvalid?true:null" class="btn-secondary btn  btn-block btnlogin  m-1" (click)="opennexttab('tab2cont')">
              </li></ul>
        </div>
            </div>
            </form>
      </section>
      <section [ngClass]="tab3cont ? 'tab-pane fade show active' : 'tab-pane fade' " id="tab3cont" role="tabpanel">
        <form method="post" role="form" [formGroup]="Requestform" (ngSubmit)="onSubmit(Requestform.value)"> 
        <div class="content-wrapper">
          <h4 class="section-heading">Documents Upload</h4>
          <div class="form-group">
            <div class="mb-3">
              <div class="row">
                <div class="col-md-6">
                  <label  class="control-label">Upload Photo<span class="strip">*</span></label>
                  <input type="file" formControlName="upload_photo" accept="image/jpeg"  name="upload_photo" id="upload_photo"  class="form-control"
                  [ngClass]="{ 'is-invalid': submitted && f.upload_photo.errors }" (change)="getphoto($event)"/>
                  
                  <div *ngIf="submitted && f.upload_photo.errors" class="invalid-feedback">
                    <div *ngIf="f.upload_photo.errors.required">Please upload photo.</div>
                  </div>
                  
                </div>
                <div class="col-md-6 mt-3">
                  <span *ngIf="attachedphoto" class="text-success">  <i class="bi bi-check-circle" style="font-size: 2.5rem;"></i></span>
                </div>
                <div *ngIf="photoinfo" class="col-md-6" style="margin-top:2rem">
                     <!-- Preview -->
                      <button type="button" class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#photopreview">
                        Preview Uploaded Photo
                      </button>

                      <!-- Modal -->
                      <div class="modal fade" id="photopreview" data-bs-backdrop="static" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered">
                          <div class="modal-content">
                            <div class="modal-header modalheader ">
                              <h5 class="modal-title" id="exampleModalLabel">Uploaded Photo</h5>
                              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body viewimgmodalbody">
                                <img [src]="photoinfo">
                            </div>
                            <div class="modal-footer">
                              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                            </div>
                          </div>
                        </div>
                      </div>  
              
                   <!--  -->

                </div>
            </div>  
            </div>
            </div>
            <div class="form-group">
              <div class="row">
              <div class="col-md-6">
                  <label for="inputEmail3" class="col-form-label">Upload Marksheet for {{selectedstandard}} exam<span class="strip">*</span></label>
                  <input type="file"   formControlName="upload_marksheet" accept="application/pdf"  name="upload_marksheet" id="upload_marksheet"  class="form-control"
                  [ngClass]="{ 'is-invalid': submitted && f.upload_marksheet.errors }" (change)="getmarksheet($event)"/>
                  <div *ngIf="submitted && f.upload_marksheet.errors" class="invalid-feedback">
                    <div *ngIf="f.upload_marksheet.errors.required">Please upload Marksheet</div>
                  </div>
                  
              </div>
              <div class="col-md-6 mt-4">
                <span *ngIf="attachedmarksheet" class="text-success">  <i class="bi bi-check-circle" style="font-size: 2.5rem;"></i></span>
              </div>
              <div *ngIf="marksinfo" class="col-md-6" style="margin-top:3rem">
                <!-- Preview -->
                 <a [href]="marksinfo" class="btn btn-outline-success" download target="_blank">
                   Download to Preview Uploaded Marksheet.
                 </a>

                 <!-- Modal -->
                 <!-- <div class="modal fade" id="markspreview" data-bs-backdrop="static" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                   <div class="modal-dialog modal-dialog-centered">
                     <div class="modal-content">
                       <div class="modal-header modalheader">
                         <h5 class="modal-title" id="exampleModalLabel">Uploaded Marksheet</h5>
                         <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                       </div>
                       <div class="modal-body viewimgmodalbody">
                           <img [src]="marksinfo">
                       </div>
                       <div class="modal-footer">
                         <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                       </div>
                     </div>
                   </div>
                 </div>   -->
         
              <!--  -->

           </div>
          </div>  
            <!-- <div class="">
              <label for="inputEmail3" class="col-form-label">Upload Marksheet<span class="strip">*</span></label>
              <input type="file"   formControlName="upload_marksheet"  name="upload_marksheet" id="upload_marksheet"  class="form-control"
              [ngClass]="{ 'is-invalid': submitted && f.upload_marksheet.errors }" (change)="getmarksheet($event)"/>
              <div *ngIf="submitted && f.upload_marksheet.errors" class="invalid-feedback">
                <div *ngIf="f.upload_marksheet.errors.required">Please upload marksheet</div>
                  </div>
              </div> -->
            </div>
          <div class="actions clearfix">
            <ul role="menu" aria-label="Pagination">
              <!-- <li aria-hidden="false" aria-disabled="false">
                <input type="submit" value="Save" class="btn btn-warning  btn-block btnlogin  m-1">
               </li> -->
               <li aria-hidden="false" aria-disabled="false">
                <input value="Previous" type="button" class="btn btn-secondary  btn-block btnlogin  m-1" (click)="opennexttab('tab1cont')">
              </li>
              <li aria-hidden="false" aria-disabled="false">
                <input value="Next" type="button" class="btn btn-secondary  btn-block btnlogin  m-1" (click)="opennexttab('tab3cont')">
              </li><li aria-hidden="true" style="display: none;">
                <input value="Next" type="button" class="btn btn-secondary  btn-block btnlogin  m-1" (click)="opennexttab('tab4cont')">
              </li></ul></div>
        </div>
        </form>
      </section>
     <section [ngClass]="tab4cont ? 'tab-pane fade show active' : 'tab-pane fade' " id="tab4cont" role="tabpanel">
      <!-- <form method="post" role="form"  name="form1" #form="ngForm" [formGroup]="paymentform" (ngSubmit)="getfees()">  -->
        <div class="content-wrapper ">
          <h4 class="section-heading mb-5">Payment Details</h4>
          <!-- <form name="conv_FeePaymentDetailsform" class="ng-invalid ng-invalid-required ng-dirty ng-valid-parse"> -->
            <div class="form-group">
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <div class="col-md-12 row">
                                <div class="col-md-3">
                                    <label class="control-label"> Certificate reciept mode :</label>
                                </div>
                                <div class="col-md-3">
                                  <div class="form-check">
                                    <input class="form-check-input" type="radio"  
                                    name="certificate_delivery_mode1"  id=" certificate_delivery_mode1" value="by_post"    
                                    (change) = "toggleDisplay($event.target)"/>
                                    <label class="form-check-label" >
                                      By Post
                                    </label><br>
                                    
                                    <input class="form-check-input" type="radio"  name="certificate_delivery_mode1" 
                                    id=" certificate_delivery_mode2" value="by_person"  (change) = "toggleDisplay($event.target)"/>
                                    <label class="form-check-label" >
                                      In person
                                    </label>
                                    </div>
                                    </div>
                        </div>
                        <div class="row mt-3">
                          <div>
                         <h6 *ngIf="isShow" class="strip "><span class=" mx-3">Note:</span>{{paymentmsg}} <b></b></h6>
                          </div>
                        </div>
                        <div class="col-md-12 row">
                          <div class="col-md-3">
                            <label class="control-label">Choose Fees Payment mode :</label>
                          </div>
                          <div class="col-md-4">
                              <div class="form-check">
                                  <input class="form-check-input" type="radio" name="MOP"  id="debitmode" value="4"  (change)="getpaymentmode($event.target)"/>
                                  <label class="form-check-label" >
                                    Debit Card
                                  </label><br>
                                  
                                  <input class="form-check-input" type="radio" name="MOP" id="creditmode" value="5"  (change)="getpaymentmode($event.target)"/>
                                  <label class="form-check-label" >
                                    Credit Card
                                  </label>
                              </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-check">
                              <input class="form-check-input" type="radio" name="MOP"  id="debitmode" value="6"  (change)="getpaymentmode($event.target)"/>
                              <label class="form-check-label" >
                                UPI
                              </label><br>
                              
                              <input class="form-check-input" type="radio" name="MOP" id="creditmode" value="3" (change)="getpaymentmode($event.target)"/>
                              <label class="form-check-label" >
                                Net Banking
                              </label>
                          </div>                      
                                 
                          </div>

                        </div>
                    </div>
                </div>
            </div>
          </div>
        <!-- </form>                      -->
        <div class="actions">
          <ul class="row">
            <li class="col-sm-6"></li>
            <li aria-hidden="false" class="col-sm-3" aria-disabled="false">
              <input type="submit" (click)="checkstudvalid()" value=" Goto Payment" class="btn btn-warning btn-block btnlogin  m-1" 
               [disabled]="!isChecked">
            </li>
           <!-- <li aria-hidden="false" aria-disabled="false">
              <input value="Submit" type="button" class="btn btn-success  btn-block btnlogin  m-1 text-white" (click)="submit()" >
            </li>-->
             <li aria-hidden="false" class="col-sm-3" aria-disabled="false">
              <input value="Previous" type="button" class="btn btn-secondary  btn-block btnlogin  m-1" (click)="openpretab('tab3cont')">
            </li>
            <!-- <li aria-hidden="false" aria-disabled="false">
              <input value="Next" type="button" class="btn-secondary btn  btn-block btnlogin  m-1" (click)="opennexttab('tab4cont')">
            </li> -->
          </ul>
      </div>
            </div> 
            <!-- </form> -->
      </section>
    </div></div>
  </div>
  </section>
  <div [ngStyle]="{'display':displayStyle}" class="modalbackdrop modal pt-5 fade show" id="paymentmodal" tabindex="-1"  
        aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header ">
          <h5 class="modal-title" id="exampleModalLabel">Payment Confirmation</h5>
          <button type="button" (click)="closePaymentmodal()" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <form  form method="post" role="form" name="form1" #form="ngForm" [formGroup]="paymentform" (ngSubmit)="paymentdetails(paymentform.value)">
         <!-- <form method="post" role="form" [formGroup]="Requestform" (ngSubmit)="onSubmit(Requestform.value)">   -->
        <div class="modal-body">
          <div class="form-group">
          <div class="row">
            <div class="col-md-6">
            <label for="inputPassword3" class="form-label">Selected Mode For delivery</label>
            <input type="text" [attr.disabled]="formdisable" [value]="deliverymode" formControlName="certificate_delivery_mode" name="certificate_delivery_mode"  id=" certificate_delivery_mode" class="form-control">
            </div>
            <div class="col-md-6">
              <label class="form-label" >Requested For</label>
              <input class="form-control"  [attr.disabled]="formdisable" [value]="application_type_requested" type="text" formControlName="application_type" name="application_type">
            </div>
            </div>
          </div>
            <div class="form-group">
            <div class="row">
              <div class="col-md-6">
                <label>Basic Charges </label>
                <input class="form-control" formControlName="payment" name="payment"  id=" payment" type="number"  [value]="feesData" [readonly]="true">
               </div>
              <div class="col-md-6">
                <label>Extra Charge If any</label>
                <input class="form-control"  formControlName="extra_charges_pay" name="extra_charges_pay"  id="extra_charges_pay" type="number" [value]="feesData1" [readonly]="true" >
               </div>
              </div>
              </div>
              <div class="form-group">
                <div class="row">
                <div class="">
                 <label>Total Amount to be Paid</label>
                 <input class="form-control"  formControlName="total_payment"  name="total_payment"  id="total_payment" type="number" [value]="total_fees" [readonly]="true">
                </div>
                </div>
        </div>
        </div>
      
        <div class="text-end m-3">
          <button  type="submit"  class="btn btn-primary mx-3">Proceed To Pay</button>
          <button type="button" class="btn btn-secondary" (click)="closePaymentmodal()" >Close</button>
        </div>
      </form>
      </div>
    </div>
  </div>
  <!-- <div class="modal" id="myModal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Modal title</h4>    
          <button type="button" class="close" data-dismiss="modal">×</button>
        </div><div class="container"></div>
        <div class="modal-body">
          ...
          <a data-toggle="modal" href="#myModal2" class="btn btn-primary">Open modal2</a>
        </div>
        <div class="modal-footer">
          <a href="#" data-dismiss="modal" class="btn">Cancel</a>
        </div>
      </div>
    </div>
</div> -->
<div *ngIf="proccessing" class="loadingcont">
  <div class="spinner"></div>
</div>
<!-- <button (click)="varifypayment()" class="btn ">check payment</button>  -->